import FavoriteVariantCharacters from "@/services/favoriteVariantCharacters.service.js";

export default class FavoriteVariantCharactersUsecase {
  constructor () {
    this.FavoriteVariantCharacters = new FavoriteVariantCharacters();
  }

  async getFavoriteVariantCharacters (options) {
    const res = await this.FavoriteVariantCharacters.get(options);
    return res;
  }

  async updateFavoriteVariantCharacter (options) {
    const res = await this.FavoriteVariantCharacters.update(options);
    return res;
  }

  async deleteFavoriteVariantCharacter (options) {
    const res = await this.FavoriteVariantCharacters.delete(options);
    return res;
  }
}
